import React from 'react';
import { Helmet } from 'react-helmet';
import Button from '../components/ui/Button';
import { Mail, Clock, MapPin } from 'lucide-react';
export default function Contact() {
  return <main className="min-h-screen bg-white" data-id="element-381">
      <Helmet data-id="element-382">
        <title data-id="element-383">Contact Medico-Legal Psychiatry – Expert Witness Services</title>
        <meta name="description" content="Contact Medico-Legal Psychiatry. Email Dr. Imtiaz Syed for medico-legal assessments, expert witness reports & psychiatric evaluations across the UK." data-id="element-384" />
        <meta name="keywords" content="Contact Medico-Legal Psychiatry, Expert Witness Psychiatrist UK, Legal Psychiatric Assessment, Dr Imtiaz Syed Contact, Independent Psychiatric Reports UK" data-id="element-385" />
        <script type="application/ld+json" data-id="element-386">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ContactPage",
              "name": "Contact Medico-Legal Psychiatry",
              "description": "Contact Dr. Imtiaz Syed for expert psychiatric assessments and reports for legal proceedings. Remote or in-person services available nationwide.",
              "mainEntity": {
                "@type": "Organization",
                "name": "Medico-Legal Psychiatry",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "customer service",
                  "email": "enquiries@medicolegal-psychiatry.co.uk",
                  "availableLanguage": ["English", "Urdu", "Hindi", "Punjabi"]
                },
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                    "opens": "09:00",
                    "closes": "17:00"
                  },
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": "Saturday",
                    "opens": "09:00",
                    "closes": "13:00"
                  }
                ]
              }
            }
          `}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white py-10" data-id="element-387">
        <div className="container mx-auto px-4" data-id="element-388">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-389">
            Contact Medico-Legal Psychiatry
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center" data-id="element-390">
            Get in Touch for Expert Psychiatric Assessments
          </p>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-391">
        <div className="container mx-auto px-4" data-id="element-392">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-393">
            <p className="text-slate-dark text-lg mb-6" data-id="element-394">
              We've made it easy for you to reach us. Choose the method that
              works best for you:
            </p>
            <ul className="space-y-6 mb-8" data-id="element-395">
              <li className="flex items-start" data-id="element-396">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-397">
                  <Mail className="h-6 w-6" data-id="element-398" />
                </div>
                <div data-id="element-399">
                  <h3 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-400">
                    Direct Email
                  </h3>
                  <p className="text-slate-dark mb-2" data-id="element-401">
                    For detailed inquiries and to send instruction bundles, you
                    can email us directly:
                  </p>
                  <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-primary hover:text-secondary transition-colors" data-id="element-402">
                    enquiries@medicolegal-psychiatry.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-403">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-404">
                  <Clock className="h-6 w-6" data-id="element-405" />
                </div>
                <div data-id="element-406">
                  <h3 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-407">
                    Our Hours
                  </h3>
                  <p className="text-slate-dark mb-2" data-id="element-408">
                    Our team is available to process your messages and
                    coordinate discussions during:
                  </p>
                  <ul className="space-y-1 text-slate-dark" data-id="element-409">
                    <li data-id="element-410">
                      Monday to Friday: 9:00 AM to 5:00 PM (GMT/BST) (excluding
                      Bank Holidays)
                    </li>
                    <li data-id="element-411">Saturdays: 9:00 AM to 1:00 PM (GMT/BST)</li>
                    <li data-id="element-412">Sundays: Closed</li>
                  </ul>
                  <p className="text-slate mt-2" data-id="element-413">
                    Messages received outside of these hours will be addressed
                    promptly on the next working day.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-414">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-415">
                  <MapPin className="h-6 w-6" data-id="element-416" />
                </div>
                <div data-id="element-417">
                  <h3 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-418">
                    Accessibility and Flexibility
                  </h3>
                  <p className="text-slate-dark" data-id="element-419">
                    Dr. Syed offers exceptional flexibility to accommodate your
                    needs and those of your clients. He can conduct remote
                    assessments across all regions of the UK. For your
                    convenience, in-person assessments can also be arranged, and
                    Dr. Syed is available for prison visits, care home visits,
                    and court attendance when required.
                  </p>
                </div>
              </li>
            </ul>
            <p className="text-slate-dark text-lg mb-6" data-id="element-420">
              We look forward to partnering with you to provide the expert
              psychiatric insights your cases require.
            </p>
          </div>
          {/* Email Contact Section (Replacing Form) */}
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8 text-center" data-id="element-421">
            <h2 className="text-2xl font-serif font-bold text-primary mb-6" data-id="element-422">
              Contact Us Directly
            </h2>
            <div className="mb-8" data-id="element-423">
              <p className="text-slate-dark text-lg mb-4" data-id="element-424">
                For all inquiries regarding medico-legal assessments, expert
                witness services, or to discuss your specific case requirements,
                please email us directly. We aim to respond to all messages
                within 24 hours during business days.
              </p>
              <p className="text-slate-dark text-lg mb-6" data-id="element-425">
                Please include your name, contact information, and a brief
                description of your inquiry to help us assist you more
                efficiently.
              </p>
            </div>
            <div className="flex justify-center" data-id="element-426">
              <Button variant="primary" size="lg" href="mailto:enquiries@medicolegal-psychiatry.co.uk?subject=Medico-Legal%20Inquiry" data-id="element-427">
                <Mail className="h-5 w-5 mr-2" data-id="element-428" />
                Email Us Now
              </Button>
            </div>
          </div>
        </div>
      </section>
    </main>;
}